export default __webpack_public_path__ + "static/media/filter.f8386172.jpg";